import React, { useState, useEffect } from 'react';
import LinkWithIcon from '@legacy-vfuk/core-link-with-icon';
import LoadingSpinner from '@legacy-vfuk/core-loading-spinner';
import SimpleGrid from '@legacy-vfuk/core-simple-grid';
import '../css/TopSearches.css';
import {
  KOA_API_ENDPOINT,
  OPCO_CODE,
  LANG_CODE,
} from '../../SectionAssessment/SectionAssessmentSurvey/SectionAssessmentBusinessGoals/SectionAssessmentBusinessGoals';
import { navigate } from 'gatsby';
import { TopSearchesProps, TopQuestions } from '../Types/TopSearchesTypes';
import twinxClient from '../ProtectedApiClient';
import ShowError from '../../SectionAssessment/ShowError';
import {
  LoadingSpinnerWrapper,
  SimpleGridWrapper,
} from './styles/TopSearches.styles';
import fireButtonAndLinkClicksEvent from "../../../../../helpers/fireButtonAndLinkClicksEvent";

const TopSearches = ({
  content,
  navigateSlug,
  category,
  error,
  getDocumentListAPI,
  executeScroll,
}: TopSearchesProps) => {
  const [topTenQuestions, setTopTenQuestions] = useState<
    TopQuestions[] | string[]
  >([]);
  const [errorForTopSearch, setErrorForTopSearch] = useState<string>('');
  const getTopTenQuestionsByKoa = async () => {
    const params = `Opco=${OPCO_CODE}&Language=${LANG_CODE}&Query=9`;

    try {
      const { data } = await twinxClient.get(
        `${KOA_API_ENDPOINT}/toptenquestions?${params}`
      );
      const errorStatus = data.result.status;
      if (!data.result.status && !data.result.fault) {
        setTopTenQuestions(data.result);
      } else {
        apiErrorHandler(errorStatus);
      }
    } catch (error) {
      if (!window.navigator.onLine) {
        setErrorForTopSearch('noInternetError');
      } else {
        setErrorForTopSearch(
          error.message === undefined ? 'noData' : 'serverError'
        );
      }
    }
  };

  const apiErrorHandler = (errorStatus: string) => {
    const serverError = ['500', '504', '403', '429'].indexOf(errorStatus);
    if (serverError === 0) {
      setErrorForTopSearch('serverError');
    } else {
      setErrorForTopSearch('noData');
    }
  };

  const getResultsByClickingTopSearch = async (searchText: string) => {
    await navigate(navigateSlug ? navigateSlug : '', {
      state: {
        category: category,
        text: searchText,
      },
    });
  };

  const staticTopsearch = content?.topSearchText?.topSearchList;

  useEffect(() => {
    if (staticTopsearch && staticTopsearch.length > 0) {
      setTopTenQuestions(staticTopsearch);
    } else {
      getTopTenQuestionsByKoa();
    }
  }, []);

  const updateHistoryState = (searchText: string) => {
    const state: any = {
      category: category,
      text: searchText,
    };
    history.pushState(state, '', navigateSlug);
  };

  const handleDocumentListApiCall = (
    text: string,
    category: string,
    type: string,
    tags: any
  ) => {
    fireButtonAndLinkClicksEvent({
      event_label: text,
      event_action: 'link click'
    });

    if (error === 'nodata') {
      updateHistoryState(text);
      getDocumentListAPI(text, category, type, tags);
      executeScroll();
    } else {
      getResultsByClickingTopSearch(text);
    }
  };

  return (
    <div className="topsearches-conatiner">
      <div style={{ marginTop: 30 }}>
        <div className="topsearches-error-Title">
          {' '}
          {error?.errorType === 'noData'
            ? content?.topSearchText?.headerTextOnError
            : content?.topSearchText?.headerText}
        </div>
      </div>
      <div>
        {topTenQuestions.length === 0 ? (
          <div>
            {errorForTopSearch ? (
              <div style={{ marginTop: 10 }}>
                <div className="topsearches-error-Text">
                  {' '}
                  {errorForTopSearch === 'noInternetError' ? (
                    <ShowError
                      errorContent={content.noInternetError}
                      errorType={errorForTopSearch}
                      customParam={'line 96 from topsearch'}
                    />
                  ) : (
                    content?.topSearchText?.errorDescription
                  )}
                </div>
              </div>
            ) : (
              <LoadingSpinnerWrapper>
                <LoadingSpinner size={5} appearance="secondary" />
              </LoadingSpinnerWrapper>
            )}
          </div>
        ) : (
          <div className="gutterTopMargin">
            <SimpleGridWrapper>
              <SimpleGrid
                columns={{
                  sm: 1,
                  md: 2,
                  lg: 3,
                }}
              >
                {topTenQuestions.map((item: any, index: number) => (
                  <LinkWithIcon
                    size={2}
                    appearance="primary"
                    text={
                      staticTopsearch ? item : item.content[0].content[0].topic
                    }
                    key={index}
                    icon={{
                      name: 'chevron-right',
                      justify: 'right',
                    }}
                    onClick={() => {
                      handleDocumentListApiCall(
                        staticTopsearch
                          ? item
                          : item.content[0].content[0].topic,
                        category,
                        '',
                        ''
                      );
                    }}
                    srText={
                      staticTopsearch ? item : item.content[0].content[0].topic
                    }
                  />
                ))}
              </SimpleGrid>
            </SimpleGridWrapper>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopSearches;
